import { formatDocument } from "utils/utils";
import { qrCodeLicenseComponent } from "../utils";
import licenseBackground from "assets/img/fundo-alvara-campina-grande-pb.png"
import { formatValidityDate, getValidityYear, getTodayFormatted } from "utils/document-utils";
import { documentsPermitteesService } from "services/documentsPermitteesService";
  
export async function generatePrintLicenseHtml(config, data, user, breakNewPage = false) {
  const response = await documentsPermitteesService.find(data.id);
  const validity = response.data_validade;

  const html = `
    <div>
        <img style="position:absolute;top:0in;left:0in;width:8.27in;height:11.69in;" src="${licenseBackground}" />
        <div style="
            width: 8.27in;
            height: 11.69in;
            transform: scale(0.916);
            transform-origin: top left;
            position: absolute;
        ">
            <div style="position:absolute;top: 0.95in;left: 0.97in;line-height:0.20in;"><span
                style="font-style:normal;font-weight:bold;font-size:20pt;font-family:Helvetica;">${getValidityYear(validity)}</span></div>
            <div style="position:absolute;top:3.50in;left:1.25in;line-height:0.20in;"><span
                    style="font-style:normal;font-weight:normal;font-size:14pt;font-family:Helvetica;color:#000000">${getValidityYear(validity)}</span></div>
            <div style="position:absolute;top:3.50in;left:4.72in;line-height:0.20in;font-style:normal;font-weight:normal;font-size:14pt;font-family:Helvetica;color:#000000">${data.transport_permission.numero}${data.transport_permission.cab ? data.transport_permission.location.numero : ""}</div>
            <div style="position:absolute;top:4.01in;left:1.25in;line-height:0.20in;"><span
                    style="font-style:normal;font-weight:normal;font-size:14pt;font-family:Helvetica;color:#000000">${data.transport_permission.proprietario.nome}</span></div>
            <div style="position:absolute;top:4.54in;left:1.25in;line-height:0.17in;"><span
                    style="font-style:normal;font-weight:normal;font-size:12pt;font-family:Helvetica;color:#000000">${ data.transport_permission.proprietario.logradouro}, ${data.transport_permission.proprietario.numero}, ${data.transport_permission.proprietario.bairro }</span></div>
            <div style="position:absolute;top:5.04in;left:1.25in;line-height:0.20in;"><span
                    style="font-style:normal;font-weight:normal;font-size:14pt;font-family:Helvetica;color:#000000">${formatDocument(data.transport_permission.proprietario.cpf_cnpj)}</span></div>
            <div style="position:absolute;top:5.04in;left:4.72in;line-height:0.20in;"><span
                    style="font-style:normal;font-weight:normal;font-size:14pt;font-family:Helvetica;color:#000000">${data.transport_permission.proprietario.identidade} ${data.transport_permission.proprietario.orgao_expedidor} ${data.transport_permission.proprietario.uf_identidade}</span></div>
            <div style="position:absolute;top:5.58in;left:1.25in;line-height:0.15in;"><span
                    style="font-style:normal;font-weight:normal;font-size:10pt;font-family:Helvetica;color:#000000">${data.transport_permission_location.tipo.toUpperCase()}</span></div>
            <div style="position:absolute;top:5.56in;left:4.95in;line-height:0.20in;"><span
                    style="font-style:normal;font-weight:normal;font-size:14pt;font-family:Helvetica;color:#000000">${data.transport_permission.data_inicio_atividade}</span></div>
            <div style="position:absolute;top:5.56in;left:6.40in;line-height:0.20in;"><span
                    style="font-style:normal;font-weight:normal;font-size:14pt;font-family:Helvetica;color:#000000">${data.transport_permission.proprietario.cnh}</span></div>
            <div style="position:absolute;top:6.07in;left:1.25in;line-height:0.20in;"><span
                    style="font-style:normal;font-weight:normal;font-size:14pt;font-family:Helvetica;color:#000000">${data.transport_permission.veiculo.placa ? data.transport_permission.veiculo.placa + "/" + data.transport_permission.veiculo.uf_placa : ""}</span></div>
            <div style="position:absolute;top:6.07in;left:3.26in;line-height:0.20in;"><span
                    style="font-style:normal;font-weight:normal;font-size:14pt;font-family:Helvetica;color:#000000">${data.transport_permission.veiculo.numero_renavam}</span></div>
            <div style="position:absolute;top:6.07in;left:5.63in;line-height:0.20in;"><span
                    style="font-style:normal;font-weight:normal;font-size:14pt;font-family:Helvetica;color:#000000">${data.transport_permission.veiculo.numero_chassi}</span></div>
            ${data.transport_permission.cab ?
                `<div style="position:absolute;top:6.61in;left:1.25in;line-height:0.15in;"><span
                    style="font-style:normal;font-weight:normal;font-size:11pt;font-family:Helvetica;color:#000000">PRAÇA
                    ${data.transport_permission_location.numero} ${data.transport_permission_location.logradouro} | PONTO:
                    ${data.transport_permission.numero}</span></div>`
                :
                `<div style="position:absolute;top:6.61in;left:1.25in;line-height:0.15in;"><span
                    style="font-style:normal;font-weight:normal;font-size:11pt;font-family:Helvetica;color:#000000">-</span></div>`
            }
            <div style="position:absolute;top:7.04in;left:4.98in;line-height:0.15in;"><span
                    style="font-style:normal;font-weight:normal;font-size:11pt;font-family:Helvetica;color:#000000">${config.company_city} – ${config.company_uf},
                    ${data.data_impressao ? data.data_impressao : getTodayFormatted()}</span></div>
            <div style="position:absolute;top:6.61in;left:5.55in;line-height:0.15in;"><span
                style="font-style:normal;font-weight:normal;font-size:11pt;font-family:Helvetica;color:#ff0000">${formatValidityDate(validity)}</span></div>
            ${await qrCodeLicenseComponent({
                position: config.transport_permission_qrcode_alignment,
                code: data.codigo_validacao
            })}
        </div>
    </div>
  `;

  return breakNewPage
  ? 
    `<div style="
        margin: auto;
        width: 8.27in;
        height: 11.69in;
        position: relative;
        overflow: hidden;
    ">
        ${html}
    </div>`
  : `<div style="
        margin: 0 auto;
        width: 8.27in;
        height: 11.69in;
        position: relative;
        overflow: hidden;
    ">
        ${html}
    </div>`;
};
